// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"326":"e50424c1","445":"211ce1ea","598":"d5561ed5"}[chunkId] + ".chunk.css";
};